import React, { Component } from 'react';
import { STATUS_QUESTAO } from '../../../const';

class CartaoResposta extends Component {

    getStatusQuestoes() {
        return this.props.statusQuestoes || [];
    }

    getDescricaoStatus(status) {

        if (status === STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA) { return "Esta questão está respondida."; }
        if (status === STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO) { return "Esta questão está em branco, ou seja, ainda não foi respondida."; }
        if (status === STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA) { return "Esta questão está marcada como dúvida."; }
        

        if (status === STATUS_QUESTAO.QUESTAO_STATUS_CORRETA) { return "Esta questão está correta."; }
        if (status === STATUS_QUESTAO.QUESTAO_STATUS_ERRADA) { return "Esta questão está errada."; }
    }

    getStatusColor(status) {
        // console.log('status ', status)
        if (status === STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA) { return " adap-light-green  "; }
        if (status === STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO) { return " edb-border adap-white"; }
        if (status === STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA) { return " adap-light-yellow  "; }

        if (status === STATUS_QUESTAO.QUESTAO_STATUS_CORRETA) { return " adap-light-green  "; }
        if (status === STATUS_QUESTAO.QUESTAO_STATUS_ERRADA) { return " adap-red "; }
    }

    getStatusIcon(status) {
        if (status === STATUS_QUESTAO.QUESTAO_STATUS_DUVIDA) {
            return <i className="adap-cartao-resposta-icon edb-small2 adap-text-red fas fa-question-circle"></i>;
        }
    }

    render() {
        //console.log(this.props.questaoAtual)
        //console.log('status questoes ', this.props.statusQuestoes)
        //this.getStatusQuestoes().map((status, index) => console.log('status ', status))
        return (<div className={"adap-white edb-round-large edb-padding " + this.props.className}>
            <div className="edb-text-bold edb-margin-small-top">Cartão de resposta</div>
            {/* <div className="edb-small  edb-margin-small-top">
                Antes de finalizar a prova, revise as questões que marcou com interrogação:
            </div> */}
            <div className="edb-margin-small-top adap-cartao-resposta-container">
                {this.getStatusQuestoes().map((status, index) => {
                    // console.log(period)
                    //console.log('actuoal ', this.props.questaoAtual)

                    return (

                        <React.Fragment key={index}>
                            {

                                this.props.questaoAtual === (index+1) && <div key={`cartaoResposta-questao${index + 1}`}
                                    title={this.getDescricaoStatus(status)}
                                    className={"edb-pointer adap-badge-large edb-margin-small-right edb-margin-small-bottom adap-border-blue" + this.getStatusColor(status)}
                                    onClick={() => this.props.onClickQuestao && this.props.onClickQuestao(index + 1)}>

                                    <span>{index + 1}</span>
                                    {this.getStatusIcon(status)}
                                </div>
                            }
                            {
                                this.props.questaoAtual !== (index+1) && <div key={`cartaoResposta-questao${index + 1}`}
                                    title={this.getDescricaoStatus(status)}
                                    className={"edb-pointer adap-badge-large edb-margin-small-right edb-margin-small-bottom" + this.getStatusColor(status)}
                                    onClick={() => this.props.onClickQuestao && this.props.onClickQuestao(index + 1)}>

                                    <span>{index + 1}</span>
                                    {this.getStatusIcon(status)}
                                </div>
                            }
                        </React.Fragment>
                    )
                }

                )}
            </div>
        </div>);
    }
}

export default CartaoResposta;